import "./date_range_picker.js";
import "#vendor/d3.js";
import "./reports/manager.js";
import "./reports/metric_summary.js";
import "./reports/metric_graph.js";
import "./reports/tooltip.js";

jQuery(document).ready(function () {
  var dateRangeInput = jQuery("#report-date-range");

  dateRangeInput.daterangepicker({
    clearButtonText: "",
    datepickerOptions: {
      numberOfMonths: 2,
    },
  });

  jQuery(document).on("click", "[data-behaviour=report-export]", function (e) {
    e.preventDefault();

    var dateRange = JSON.parse(dateRangeInput.val());
    var params = {
      start_date: dateRange.start,
      end_date: dateRange.end,
    };

    if (window.RESOURCE) {
      params.resource_type = window.RESOURCE.type;
      params.resource_id = window.RESOURCE.id;
    }

    window.open(
      jQuery(this).data("base-url") +
        "/metric_export.csv?" +
        jQuery.param(params) +
        "&" +
        window.location.search.slice(1),
      "_blank",
    );
  });

  jQuery("[data-behaviour=reporting-group]").each(function () {
    var report = new ReportsManager(this, dateRangeInput);
  });

  jQuery("[data-behaviour=agent-availability-table]").each(function () {
    var dateRange = JSON.parse(dateRangeInput.val());
    var params = {
      start_date: dateRange.start,
      end_date: dateRange.end,
    };

    var url = jQuery(this).data("base-url") + "/availability_table?" + jQuery.param(params);

    jQuery.get(url, (response) => {
      jQuery(this).html(response);
    });

    jQuery(this)
      .on("ajax:before", function () {
        jQuery(this).css("opacity", 0.5);
      })
      .on("ajax:success", function (e, response) {
        jQuery(this).html(response);
        jQuery(this).css("opacity", 1);
      });
  });
});
